export const PROPERTY_STATUS = {
  DRAFT: "vacant",
  PUBLISHED: "published",
  RENTED: "occupied",
  DISABLED: "disabled",
  RESERVED: "reserved",
  ENABLED: "enable",
  BLOCKED: "blocked",
} as const;

export type PropertyStatus = (typeof PROPERTY_STATUS)[keyof typeof PROPERTY_STATUS];

export const PROPERTY_STATUS_LABELS: Record<PropertyStatus, string> = {
  [PROPERTY_STATUS.ENABLED]: "Active",
  [PROPERTY_STATUS.DISABLED]: "Disabled",
  [PROPERTY_STATUS.DRAFT]: "Vacant",
  [PROPERTY_STATUS.RENTED]: "Occupied",
  [PROPERTY_STATUS.PUBLISHED]: "Vacant",
  [PROPERTY_STATUS.RESERVED]: "Reserved",
  [PROPERTY_STATUS.BLOCKED]: "Blocked",
};
